import { PrimaryProductKeys } from '../../constants/primary-product-keys';
import { serveChatConvergenceExperiment } from '../experiments/serve-chat-convergence-experiment';

export const isRovoJourneyIdEnabled = (primaryProduct: string | undefined): boolean => {
	const { chatIntentDetectionEnabled } = serveChatConvergenceExperiment();
	return (
		chatIntentDetectionEnabled &&
		(primaryProduct === PrimaryProductKeys.Confluence ||
			primaryProduct === PrimaryProductKeys.Atlas)
	);
};

export const normalizeRovoJourneyId = (value: unknown): string | undefined =>
	typeof value === 'string' && value.length > 0 ? value : undefined;
